<template>
  <div>
    <b-row>
      <b-card
        no-body
        class="card-statistics"
      >
        <b-card-header>
          <b-card-title>{{ $t('Credit Limit Overview') }}</b-card-title>
          <feather-icon
            icon="RotateCwIcon"
            class="cursor-pointer"
            @click="fetchCreditLimitOverview"
          />
        </b-card-header>
        <b-card-body
          class="card-resize"
        >
          <b-row>
            <b-col
              xl="6"
              sm="6"
            >
              <b-card
                class="card card-credit-limit-1"
              >
                <feather-icon
                  icon="PieChartIcon"
                  size="50"
                  class="dashboard-left-icon mt-1 text-white"
                />
                <div>
                  <h5 class="text-white text-capitalize ml-4">
                    <span style="font-size:25px; font-weight: 600;">{{ creditLimitOverview.approvedCreditLimit }}</span>

                  </h5>
                  <b-card-text
                    class="card-title text-white ml-2 mt-2 mb-0"
                  >
                    Approved Credit Limit
                  </b-card-text>
                </div>

              </b-card>
            </b-col>
            <b-col
              xl="6"
              sm="6"
            >
              <b-card
                class="card card-credit-limit-2"
              >
                <feather-icon
                  icon="BarChartIcon"
                  size="50"
                  class="dashboard-left-icon mt-1 text-white"
                />
                <div>
                  <h5 class="text-white text-capitalize ml-4">
                    <span style="font-size:25px; font-weight: 600;">{{ creditLimitOverview.amountUtilized }}</span>
                  </h5>
                  <b-card-text
                    class="card-title text-white ml-2 mt-2 mb-0"
                  >
                    Amount Ultilized
                  </b-card-text>
                </div>

              </b-card>
            </b-col>
            <b-col
              xl="6"
              sm="6"
            >
              <b-card
                class="card card-credit-limit-3"
              >
                <feather-icon
                  icon="BarChart2Icon"
                  size="50"
                  class="dashboard-left-icon mt-1 text-white"
                />
                <div>
                  <h5 class="text-white text-capitalize ml-4">
                    <span style="font-size:25px; font-weight: 600;">{{ creditLimitOverview.availableBalance }}</span>

                  </h5>
                  <b-card-text
                    class="card-title text-white ml-2 mt-2 mb-0"
                  >
                    Available Balance
                  </b-card-text>
                </div>

              </b-card>
            </b-col>
            <b-col
              xl="6"
              sm="6"
            >
              <b-card
                class="card card-credit-limit-4"
              >
                <feather-icon
                  icon="FilterIcon"
                  size="50"
                  class="dashboard-left-icon mt-1 text-white"
                />
                <div>
                  <h5 class="text-white text-capitalize ml-4">
                    <span style="font-size:25px; font-weight: 600;">{{ creditLimitOverview.percentageUsed >= 0 ? `${creditLimitOverview.percentageUsed}%` : '' }}</span>

                  </h5>
                  <b-card-text
                    class="card-title text-white ml-2 mt-2 mb-0"
                  >
                    Percentage of Credit Limit Used
                  </b-card-text>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-card-body>
        <Spinner :show="isLoadingCreditLimitOverview" />
      </b-card>
    </b-row>
  </div>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol,
} from 'bootstrap-vue'
import { onMounted, ref } from '@vue/composition-api'
import { useActions } from 'vuex-composition-helpers'
import Spinner from '@/views/components/spinner/Spinner.vue'
import useToastAlert from '../../../composable/useToast'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    Spinner,
  },
  setup() {
    const { getCreditLimitOverview } = useActions({ getCreditLimitOverview: 'dashboard/getCreditLimitOverview' })
    const { toastAlert } = useToastAlert()
    const creditLimitOverview = ref([])
    const isLoadingCreditLimitOverview = ref(false)

    const fetchCreditLimitOverview = async () => {
      try {
        isLoadingCreditLimitOverview.value = true
        const response = await getCreditLimitOverview({ permission: 'VIEW_PFI_DASHBOARD' })

        const { status, data } = response
        if (status === 200 && data.pfiData !== null) {
          creditLimitOverview.value = data.pfiData
          isLoadingCreditLimitOverview.value = false
        }
      } catch (err) {
        toastAlert(err)
      } finally {
        isLoadingCreditLimitOverview.value = false
      }
    }

    onMounted(async () => {
      await fetchCreditLimitOverview()
    })

    return {
      creditLimitOverview,
      fetchCreditLimitOverview,
      isLoadingCreditLimitOverview,
    }
  },
}
</script>

<style lang="scss" scoped>
  .card-credit-limit-1 {
    background: #af77e7;
    color: white;
  }
  .card-credit-limit-2 {
    background: #d4b95e;
    color: white;
  }
  .card-credit-limit-3 {
    background: #dd5555;
    color: white;
  }
  .card-credit-limit-4 {
    background: #6da86b;
    color: white;
  }
  .card-resize {
    margin-top: -10px;
    margin-bottom: -20px;
  }
  .card-title {
    font-size:12px;
    font-weight: 600;
    word-break: break-word;
  }
</style>
